import { render, staticRenderFns } from "./LiefengUploadExcel.vue?vue&type=template&id=15a0b8d4&scoped=true&"
import script from "./LiefengUploadExcel.vue?vue&type=script&lang=js&"
export * from "./LiefengUploadExcel.vue?vue&type=script&lang=js&"
import style0 from "./LiefengUploadExcel.vue?vue&type=style&index=0&id=15a0b8d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a0b8d4",
  null
  
)

export default component.exports